import jwt_decode from 'jwt-decode'
export default {
    name: "DepositManage",
    data() {
        return {
            searchForm: {
                page: 1,
                pageSize: 50
            },
            depositManageForm: {
                totalMoney: null,
                payType : null
            },
            weixinPayImage: "",
            payShow: false,
            balance: null,
            tableData: [],
            selected: [],
            total: 0
        }
    },
    mounted: function () {
    },
    created() {
        this.init();
        this.getBalance();
    },
    computed: {
        rules() {
            return {
                totalMoney: [
                    {required: true, message: this.$t('depositManage.message.totalMoney'), trigger: 'blur'}
                ],
                payType: [
                    {required: true, message: this.$t('depositManage.message.payType'), trigger: 'change'}
                ]
            }
        },
    },
    methods: {
        init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
            this.$routerUtil.clearParam();
            if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
            }
        },
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            this.getBalance();
            const param = Object.assign({}, this.$paramUtil.clearEmpty(this.searchForm));
            if(param.createTime){
                param.createTimeStart = param.createTime[0];
                param.createTimeEnd = param.createTime[1];
                delete param.createTime;
            }

            this.$axios.get('/api/payitem/pageablePayItems', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
                this.selected = [];
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doReset() {
            this.$refs.form.resetFields();
        },
        doPay(){
            this.initWebSocket();
            this.payShow = true;
        },
        submitForm(formName) {
            const param = Object.assign({}, param, this.depositManageForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(param.payType);
                    if (param.payType === "0") {
                        param.totalMoney = Number(param.totalMoney*100);
                        console.log(param);
                        const token = sessionStorage.getItem('token');
                        this.weixinPayImage = "/api/wxpays/pay?totalMoney=" + param.totalMoney 
                        + "&access_token=" + token;
                    } 
                    // 支付宝支付
                    console.log("alipay");
                    if (param.payType === "1") {
                        const params = { totalMoney: Number(param.totalMoney)};
                        let routeData = this.$router.resolve({
                            name: "alipay",
                            query: params,
                         });
                         window.open(routeData.href, '_blank');
                    } 
                }
            });
        },
        // 重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.weixinPayImage = '';
        },
        // 支付方式改变
        payTypeChange(event) {
            console.log(event)
            // this.resetForm('depositManageForm');
        },
        initWebSocket: function () {                
            // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https            
            const token = sessionStorage.getItem('token');    
            const tokenJson = jwt_decode(token);
            const userId = tokenJson.userAccountId;
            const url = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/socket`
			this.websock = new WebSocket(`${url}/websocket/${userId}`);                
			this.websock.onopen = this.websocketonopen;                
			this.websock.onerror = this.websocketonerror;                
			this.websock.onmessage = this.websocketonmessage;                
			this.websock.onclose = this.websocketclose;              
		},              
		websocketonopen: function () {                
            console.log("WebSocket连接成功");        
		},              
		websocketonerror: function (e) {                
			console.log("WebSocket连接发生错误", e);              
		},              
		websocketonmessage: function (e) {                
            console.log(e.data);  
            let type = 'error';
            if (e.data === 'SM-101') {
                type = 'success';
                this.weixinPayImage = '';
                this.resetForm('depositManageForm');
                this.payShow = false;
                this.doSearch();
            }   
            this.$message({
                message: this.$t(e.data),
                type: type,
                center: true
            });                    
		},              
		websocketclose: function (e) {                
			console.log("connection closed (" + e.code + ")");              
		},
        getBalance(){
            this.$axios.get('/api/customerinfo/selectcustomerbyparam').then(response => {
                this.balance = response.data.resultData[0].accountBalance;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if(!this.selected[0]){
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
